import { render, staticRenderFns } from "./certifsTpl.vue?vue&type=template&id=ec02c226&scoped=true&lang=html&"
import script from "./certifsTpl.vue?vue&type=script&lang=js&"
export * from "./certifsTpl.vue?vue&type=script&lang=js&"
import style0 from "./certifsTpl.vue?vue&type=style&index=0&id=ec02c226&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec02c226",
  null
  
)

export default component.exports